<template>
  <v-navigation-drawer
    v-if="userInformations"
    width="100%"
    height="calc(100% - 2rem)"
    fixed
    app
    floating
    :expand-on-hover="mini"
    :value="drawer"
    :right="$vuetify.rtl"
    class="my-4 ms-4 border-radius-xl"
    :class="!$vuetify.breakpoint.mobile ? '' : 'bg-white'"
    :data-color="sidebarColor"
    :data-theme="sidebarTheme"
  >
    <v-list-item class="pa-0" to="/">
      <v-list-item-content class="pa-0">
        <v-list-item-title class="title d-flex align-center mb-0">
          <div class="v-navigation-drawer-brand pa-5 d-flex align-center">
            <v-img
              src="@/assets/img/logo.png"
              class="navbar-brand-img ms-3"
              width="32"
              v-if="sidebarTheme == 'dark'"
            >
            </v-img>
            <v-img
              src="@/assets/img/logo-ct.png"
              class="navbar-brand-img ms-3"
              width="32"
              v-else
            >
            </v-img>
            <span class="ms-2 font-weight-bold text-sm">Oelsnitz-Ticket</span>
          </div>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <hr
      class="horizontal mb-0"
      :class="sidebarTheme == 'dark' ? 'light' : 'dark'"
    />

    <!-- Always show ManagerSelector if user has external managers OR is admin with own context -->
    <ManagerSelector v-if="hasMultipleManagers || (isRealAdmin && accessibleManagers.length > 0)" class="my-3 mx-2" />

    <v-list nav dense>
      <v-list-group
        :ripple="false"
        append-icon="fas fa-angle-down"
        class="pb-1 mx-2"
        active-class="item-active"
      >
        <template v-slot:activator>
          <v-avatar size="30" class="my-3 ms-2" rounded>
            <img
              v-if="userInformations.avatar"
              :src="getImage(userInformations.avatar)"
              alt="Avatar"
              class="border-radius-lg"
            />
            <div v-else>
              {{ userInformations && userInformations.firstname ? userInformations.firstname.charAt(0) : 'U'
              }}{{ userInformations && userInformations.lastname ? userInformations.lastname.charAt(0) : '' }}
            </div>
          </v-avatar>

          <v-list-item-content>
            <v-list-item-title class="ms-2 ps-1 font-weight-light">
              {{ userInformations.firstname }} {{ userInformations.lastname }}
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          :ripple="false"
          link
          :to="child.link"
          class="mb-1 no-default-hover py-2"
          v-for="child in userInfo"
          :key="child.title"
        >
          <span
            class="v-list-item-mini ms-0 font-weight-light text-center w-20"
            v-text="child.prefix"
          ></span>

          <v-list-item-content class="ms-2 ps-1" v-if="!child.items">
            <v-list-item-title>{{ child.title }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-content class="ms-1 ps-1 py-0" v-if="child.items">
            <v-list-group
              prepend-icon=""
              :ripple="false"
              sub-group
              no-action
              v-model="child.active"
            >
              <template v-slot:activator>
                <v-list nav dense class="pa-0">
                  <v-list-group
                    :ripple="false"
                    append-icon="fas fa-angle-down me-auto ms-1"
                    active-class="item-active"
                    class="mb-0"
                  >
                    <template v-slot:activator>
                      <v-list-item-content class="py-0">
                        <v-list-item-title>{{ child.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-group>
                </v-list>
              </template>

              <v-list-item
                v-for="child2 in child.items"
                :ripple="false"
                :key="child2.title"
                :to="child2.link"
                @click="listClose($event)"
              >
                <span class="v-list-item-mini" v-text="child2.prefix"></span>
                <v-list-item-content>
                  <v-list-item-title>{{ child2.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>

    <v-list nav dense>
      <!-- <h5
        class="
          text-uppercase text-caption
          ls-0
          font-weight-bolder
          p-0
          mx-4
          mt-4
          mb-2
          ps-2
          d-none-mini
          white-space-nowrap
        "
        :class="sidebarTheme == 'dark' ? 'text-white' : 'text-default'"
      >
        {{ userInformations.firstname }} {{ userInformations.lastname }}
      </h5>

      <v-list-item-group>
        <div v-for="(item, i) in userInfo" :key="i">
          <v-list-item
            link
            :to="item.link"
            class="pb-1 mx-2 no-default-hover py-2"
            :ripple="false"
            active-class="item-active"
            v-if="!item.external"
          >
            <v-list-item-icon class="me-2 align-center">
              <i class="material-icons-round opacity-10">{{ item.action }}</i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.title"
                class="ms-1"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            link
            :href="item.link"
            class="pb-1 mx-2 no-default-hover py-2"
            :ripple="false"
            active-class="item-active"
            v-if="item.external"
            target="_blank"
          >
            <v-list-item-icon class="me-2 align-center">
              <i class="material-icons-round opacity-10">{{ item.action }}</i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.title"
                class="ms-1"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list-item-group> -->
      <!-- 
      <h5
        class="
          text-uppercase text-caption
          ls-0
          font-weight-bolder
          p-0
          mx-4
          mt-4
          mb-2
          ps-2
          d-none-mini
          white-space-nowrap
        "
        :class="sidebarTheme == 'dark' ? 'text-white' : 'text-default'"
      >
        Info
      </h5> -->
      <hr
        class="horizontal mb-0"
        :class="sidebarTheme == 'dark' ? 'light' : 'dark'"
      />
      <v-list-item-group>
        <div v-for="(item, i) in items" :key="i">
          <v-list-item
            link
            :to="item.link"
            class="pb-1 mx-2 no-default-hover py-2"
            :ripple="false"
            active-class="item-active"
            v-if="!item.external && (!item.adminOnly || (isRealAdmin && isInOwnContext)) && (!item.adminOrManagerOnly || hasAdminOrManagerPermission || (item.posReadOnly && hasPosPermission)) && (!item.posOnly || hasPosPermission)"
          >
            <v-list-item-icon class="me-2 align-center">
              <i class="material-icons-round opacity-10">{{ item.action }}</i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="ms-1">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            link
            :href="item.link"
            class="pb-1 mx-2 no-default-hover py-2"
            :ripple="false"
            active-class="item-active"
            v-if="item.external"
            target="_blank"
          >
            <v-list-item-icon class="me-2 align-center">
              <i class="material-icons-round opacity-10">{{ item.action }}</i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="ms-1">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list-item-group>

      <!-- <h5
        class="
          text-uppercase text-caption
          ls-0
          font-weight-bolder
          p-0
          mx-4
          mt-4
          mb-2
          ps-2
          d-none-mini
          white-space-nowrap
        "
        :class="sidebarTheme == 'dark' ? 'text-white' : 'text-default'"
      >
        Do
      </h5> -->

      <hr
        class="horizontal mb-0"
        :class="sidebarTheme == 'dark' ? 'light' : 'dark'"
      />
      <v-list-item-group>
        <div v-for="(item, i) in itemsDocs" :key="i">
          <v-list-item
            link
            :to="item.link"
            class="pb-1 mx-2 no-default-hover py-2"
            :ripple="false"
            active-class="item-active"
            :exact="item.link === '/admin/administration'"
            v-if="!item.external && (!item.adminOnly || (isRealAdmin && isInOwnContext)) && (!item.adminOrManagerOnly || hasAdminOrManagerPermission || (item.posReadOnly && hasPosPermission)) && (!item.posOnly || hasPosPermission)"
          >
            <v-list-item-icon class="me-2 align-center">
              <i class="material-icons-round opacity-10">{{ item.action }}</i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="ms-1">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
            <v-chip
              v-if="item.link === '/admin/administration' && unapprovedEventsCount > 0"
              small
              class="white--text"
              style="background: #ea0606 !important; min-width: 28px; height: 28px; font-weight: 900; font-size: 13px;"
            >
              {{ unapprovedEventsCount }}
            </v-chip>
          </v-list-item>

          <v-list-item
            link
            :href="item.link"
            class="pb-1 mx-2 no-default-hover py-2"
            :ripple="false"
            active-class="item-active"
            v-if="item.external"
            target="_blank"
          >
            <v-list-item-icon class="me-2 align-center">
              <i class="material-icons-round opacity-10">{{ item.action }}</i>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="ms-1">{{
                item.title
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list-item-group>
    </v-list>

    <v-card
      class="pa-0 border-radius-lg mt-7 mb-9 mx-4"
      :style="`background-image: url(${require('../assets/img/curved-images/white-curved.jpeg')}); background-size: cover;`"
    >
      <span
        class="mask opacity-8 border-radius-lg"
        :class="`bg-gradient-` + sidebarColor"
      ></span>
    </v-card>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import coreData from "@/mixins/coreDataMixin";
import ManagerSelector from './ManagerSelector.vue';

export default {
  name: "drawer",
  components: {
    ManagerSelector
  },
  mixins: [coreData],
  props: {
    drawer: {
      type: Boolean,
      default: null,
    },
    sidebarColor: {
      type: String,
      default: "success",
    },
    sidebarTheme: {
      type: String,
      default: "dark",
    },
  },
  data: () => ({
    mini: false,
    togglerActive: false,
    thirdLevelSimple: [
      "Third level menu",
      "Just another link",
      "One last link",
    ],
    // userInfo moved to computed property
    items: [
      {
        action: "dashboard",
        link: "/admin/analytics",
        title: "Analytics",
        external: false,
        adminOrManagerOnly: true, // Nur für Admin oder Manager-Rolle
      },
      {
        action: "upcoming",
        link: "/admin/events",
        title: "Events",
        external: false,
        adminOrManagerOnly: true, // Nur für Admin oder Manager-Rolle
        posReadOnly: true, // POS-User haben Leserecht
      },
      {
        action: "receipt_long",
        link: "/admin/news",
        title: "News",
        external: false,
        adminOrManagerOnly: true, // Nur für Admin oder Manager-Rolle
      },
      {
        action: "point_of_sale",
        link: "/admin/pos/create-ticket",
        title: "POS-Tickets",
        external: false,
        posOnly: true, // Für Manager mit POS-Berechtigung ODER Manager-Rolle sichtbar
      },
    ],
    itemsDocs: [
      {
        action: "person",
        link: "/admin/administration",
        title: "Administration",
        external: false,
        adminOnly: true, // Nur für Admin-Manager sichtbar
      },
      {
        action: "person_add",
        link: "/admin/administration/invitations",
        title: "Manager-Einladungen",
        external: false,
        adminOnly: true, // Nur für Admin-Manager sichtbar
      },
    ],
  }),
  methods: {
    listClose(event) {
      let items;
      let headers;
      let groups;
      let currentEl;

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active"
        )
      ) {
        items = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active"
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active"
        )
      ) {
        headers = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active"
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active"
        )
      ) {
        groups = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active"
        );
      }

      if (
        event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group"
        )
      ) {
        currentEl = event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group"
        );
      }

      if (items != null) {
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove("item-active");
        }
      }

      if (headers != null) {
        for (var j = 0; j < headers.length; j++) {
          headers[j].classList.remove(
            "v-list-item--active",
            "item-active",
            "primary--text"
          );
          headers[j].setAttribute("aria-expanded", false);
        }
      }

      if (groups != null) {
        for (var k = 0; k < groups.length; k++) {
          groups[k].classList.remove("v-list-group--active", "primary--text");
        }
      }

      if (event.target.closest(".mb-0.v-list-item.v-list-item--link")) {
        event.target
          .closest(".mb-0.v-list-item.v-list-item--link")
          .classList.add("item-active");
      }

      if (currentEl != null) {
        currentEl
          .querySelector(".v-list-group__header")
          .classList.add("v-list-item--active", "item-active");
      }
    },
  },
  computed: {
    ...mapGetters([
      'userInformations',
      'isAdmin',
      'isRealAdmin',
      'hasMultipleManagers',
      'currentForManagerId',
      'currentForManagerName',
      'currentRole',
      'accessibleManagers',
      'isManager',
      'isPosUser',
      'isChecker',
      'canCreateEvents',
      'canSendInvitations',
      'canManageInvitations',
      'canManageRoles',
      'canArchiveEvents',
      'canHardDeleteEvents',
      'ownManagerId'
    ]),
    isInOwnContext() {
      // Check if user is in their own context (not in external manager context)
      return this.currentForManagerId && this.ownManagerId && this.currentForManagerId === this.ownManagerId;
    },
    userInfo() {
      const items = [];
      
      // "Mein Profil" nur anzeigen, wenn User echter Admin ist und eine Organisation haben könnte
      if (this.isRealAdmin && this.ownManagerId) {
        items.push({
          title: "Mein Profil",
          prefix: "MP",
          link: "/admin/profile",
          action: "person",
        });
      }
      
      // Logout immer anzeigen
      items.push({
        title: "Logout",
        link: "/logout",
        prefix: "L",
        action: "logout",
      });
      
      return items;
    },
    events() {
      return this.$store.getters.events || [];
    },
    unapprovedEventsCount() {
      // Only show unapproved events count for superadmin (60b89cf155a3dc11c0e06393)
      if (!this.userInformations || this.userInformations._id !== '60b89cf155a3dc11c0e06393') {
        return 0;
      }
      return this.events.filter(event => !event.approved).length;
    },
    // Backward compatibility für alte v-if Checks im Template
    hasAdminOrManagerPermission() {
      // Admin im eigenen Kontext: volle Rechte
      const isAdminInOwnContext = this.isAdmin && !this.$store.getters.adminSimulated && 
                                   this.currentForManagerId === this.ownManagerId;
      
      // Manager mit canManage Berechtigung
      const hasManagerPermission = this.isManager;
      
      const result = isAdminInOwnContext || hasManagerPermission;
      console.log('🔍 [DRAWER] hasAdminOrManagerPermission:', result, { 
        isManager: this.isManager, 
        isAdmin: this.isAdmin,
        isAdminInOwnContext,
        currentRole: this.currentRole,
        currentForManagerId: this.currentForManagerId,
        ownManagerId: this.ownManagerId
      });
      return result;
    },
    hasPosPermission() {
      // POS access is allowed if user has POS, Manager, or Admin role (even if they also have Checker role)
      // Users with multiple roles (e.g. Checker + POS/Manager) can access POS
      const result = this.isPosUser || this.isManager || (this.isAdmin && !this.$store.getters.adminSimulated);
      console.log('🔍 [DRAWER] hasPosPermission:', result, { 
        isPosUser: this.isPosUser,
        isManager: this.isManager,
        isAdmin: this.isAdmin,
        isChecker: this.isChecker,
        currentRole: this.currentRole
      });
      return result;
    }
  },
  methods: {
    setCurrentForManager(forManagerId) {
      this.$store.dispatch('AuthStore/setCurrentForManager', forManagerId);
      // Optional: Seite neu laden oder zu Dashboard navigieren
      if (this.$route.path !== '/admin/analytics') {
        this.$router.push('/admin/analytics').catch(() => {});
      }
    }
  },
  mounted() {
    this.$store.dispatch("tryAutoLogin");
    // Load events for unapproved count (only for admins)
    // Use current year to avoid loading all historical events
    if (this.isRealAdmin) {
      const currentYear = new Date().getFullYear();
      console.log('📅 [DRAWER] Loading events for unapproved badge with year:', currentYear);
      this.$store.dispatch("getEventsAdmin", { 
        includeArchived: false,
        year: currentYear // Only load current year events for badge
      });
    }
    // console.log(this.userInformations);
    // if (this.userInformations && this.userInformations.superadmin) {
    //   this.itemsDocs.push({
    //     action: "list",
    //     link: "/admin/eventlist",
    //     title: "Eventlist",
    //     external: false,
    //   });
    // }
  },
};
</script>
